<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Segments description
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i"
                    class="tabCell"
                    :class="item.style">
                    {{ item.text }}
                </v-col>
            </v-row>
        
            <div v-if="market_segments.length">
                <!--segments tab-->
                <v-row v-for="segment in market_segments" :key="segment.id" no-gutters>
                    <v-col class="tabCell text-truncate text-left">{{ segment.segment?.name }}</v-col>
                    <v-col class="tabCell text-truncate text-left">{{ segment.segment?.description }}</v-col>
                    <v-col class="tabCell text-center">
                        {{ segment.segment?.typical_age[0] }} - {{segment.segment?.typical_age[1] }}
                    </v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.gender }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.income }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.education }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.civil_status }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.job }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment?.lifestyle }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.segment.motiv_level }}</v-col>

                    <v-col class="tabCell text-center">
                        <edit-segment :segment="segment"></edit-segment>
                        <delete-segment :segment="segment" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no segments yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>

import EditSegment from '../../../components/admin/segments/editSegment.vue'
import DeleteSegment from '../../../components/admin/segments/deleteMarketSegment.vue'
import Loader from '../../../layouts/Loader.vue'

export default {
    data() {
        return { 
            headers: [
                { text: 'Segment name', style: 'text-left'}, 
                {text: 'Sement description', style: 'text-center'}, 
                {text: 'Typical age', style: 'text-center'}, 
                {text: 'Dominant gender', style: 'text-center'},
                {text: 'Income', style: 'text-center'}, 
                {text: 'Education', style: 'text-center'}, 
                {text: 'Civil status', style: 'text-center'}, 
                {text: 'Workplace', style: 'text-center'}, 
                {text: 'Lifestyle', style: 'text-center'}, 
                {text: 'Motiv level', style: 'text-center'}, 
                {text: 'Actions', style: 'text-center'}
            ],

        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        market_segments() {
            return this.$store.getters.market_segments;
        }
    },
    methods: {
        localeNumber(num) {
            if (num) {
                    if (this.locale == 'ro-RO') {
                    return num.toLocaleString('en-US')
                }
                return num.toLocaleString(this.locale)
            }
            return 0;
        },
        
    },
    components: {
        EditSegment,
        DeleteSegment,
        Loader
    }/* ,
    async mounted() {
        if(this.segments.length < 1) {
            const obj = {
                game_id: this.set.value,
                round: 0
            }
            await this.$store.dispatch('fetchSegments', obj);
        }
    } */
}
</script>


		
